var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"map-container",staticClass:"rounded-xl",style:(`height: ${_vm.height}px`)},[_c('div',{ref:"map-autocomplete",staticClass:"ma-2 map-autocomplete d-flex justify-center"},[_c('v-text-field',{attrs:{"light":"","dense":"","filled":"","outlined":"","rounded":"","hide-details":"","placeholder":"搜尋商店名稱"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }